/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_strength_verystrong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Very strong`)
};

const es_pw_strength_verystrong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muy fuerte`)
};

const de_pw_strength_verystrong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sehr stark`)
};

const nl_pw_strength_verystrong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeer sterk`)
};

const fr_pw_strength_verystrong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Très fort`)
};

const it_pw_strength_verystrong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molto forte`)
};

const pt_br2_pw_strength_verystrong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito forte`)
};

const pt_pw_strength_verystrong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Muito forte`)
};

const ja_pw_strength_verystrong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常に強い`)
};

const zh_pw_strength_verystrong = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`非常强`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_strength_verystrong = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_strength_verystrong(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_strength_verystrong", locale)
	if (locale === "en") return en_pw_strength_verystrong(inputs)
	if (locale === "es") return es_pw_strength_verystrong(inputs)
	if (locale === "de") return de_pw_strength_verystrong(inputs)
	if (locale === "nl") return nl_pw_strength_verystrong(inputs)
	if (locale === "fr") return fr_pw_strength_verystrong(inputs)
	if (locale === "it") return it_pw_strength_verystrong(inputs)
	if (locale === "pt-BR") return pt_br2_pw_strength_verystrong(inputs)
	if (locale === "pt") return pt_pw_strength_verystrong(inputs)
	if (locale === "ja") return ja_pw_strength_verystrong(inputs)
	return zh_pw_strength_verystrong(inputs)
};